import React from 'react';
import { Container, Icon } from '@ruter-ds/rds-components';
import { TickCircleIcon } from '@ruter-ds/rds-icons';

export const ReceiptView = ({ provideCode, code }) => {
    const displayCode = provideCode === 'yes';

    return (
        <Container className="rds-my--l receiptPage">
            <Icon className="icon" component={<TickCircleIcon />} />
            <div className="message">
                <p>Takk! Skjemaet er sendt inn</p>
                {displayCode ? (
                    <p>
                        Verifikasjonskode for innsendt skjema: <b>{code}</b>
                    </p>
                ) : (
                    ''
                )}
                <p>
                    <em>Thanks! The form is submitted</em>
                </p>
            </div>
        </Container>
    );
};
